import * as React from 'react';
import { type HTMLProps } from 'react';
import * as _ from 'lodash';
// @ts-ignore
import { type Element } from 'hast';
import { safely } from '@epihub/core/src/fn/safely';
import { LottieDownloadFile } from '../Lottie';
import { styled, useTheme } from '../../theme/theme';

type TMessageTypeMarkdownFileProps = HTMLProps<HTMLAnchorElement> & {
  node: Element;
};

export const MessageTypeMarkdownFile = ({
  className,
  node,
  ...props
}: TMessageTypeMarkdownFileProps) => {
  const theme = useTheme();

  const onClick = React.useCallback(() => {
    window.open(props.href, '_blank');
  }, [props.href]);

  const children = safely(
    // @ts-ignore
    () => (!_.isString(props.children[0]) ? props.children : `${props.children[0]}`.replace('file:', '').trim()),
    () => props.children,
  );
  return (
    <Root>
      <Content>
        <StyledLottieDownloadFile
          color={[theme.legacy.colors.accent2]}
        />
        <Children onClick={onClick}>
          {children}
        </Children>
        <ClickSurface onClick={onClick} />
      </Content>
    </Root>
  );
};

const Root = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 25px;
`;

const StyledLottieDownloadFile = styled(LottieDownloadFile)`
  margin-top: -100px;
  max-width: 250px;
`;

const Children = styled.a`
  color: ${({ theme }: any) => theme.legacy.colors.accent2};
  font-weight: 500;
`;

const ClickSurface = styled.div`
  cursor: pointer;
  height: 150px;
  margin-top: 20px;
  max-width: 250px;
  position: absolute;
  width: 100%;
`;
